import { render, staticRenderFns } from "./FieldWorkplace2Info.vue?vue&type=template&id=206fac40&scoped=true"
import script from "./FieldWorkplace2Info.vue?vue&type=script&lang=js"
export * from "./FieldWorkplace2Info.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplace2Info.vue?vue&type=style&index=0&id=206fac40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fac40",
  null
  
)

export default component.exports